
// 注册全局插件
import selectCustomer from '../components/selectCustomer/index.js'

export default (app) => {
  app.use(selectCustomer);
};
